import styled from 'styled-components';

export const AcceptedDealContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;
